import type { SimpleCallback } from 'mmfintech-backend-api/types'
import { tr, useTimeout } from 'mmfintech-commons'
import { useEffect } from 'react'

import styles from './FxRateTimerRow.module.scss'

type FxRateTimerRowProps = {
  quoteExpirationDate?: string
  onTimeout?: SimpleCallback
}

const FxRateTimerRow = ({ quoteExpirationDate, onTimeout }: FxRateTimerRowProps) => {
  const expirationTime = new Date(quoteExpirationDate)

  const timeout = useTimeout({ onTimeout: () => onTimeout?.() })

  useEffect(() => {
    timeout.start(expirationTime)
  })

  return Number.isNaN(expirationTime.getTime()) ? null : (
    <div className={styles['fx-rate-timer-wrapper']}>
      <div className='rate-warning-text'>
        {tr(
          'FRONTEND.WITHDRAW.BANK_TRANSFER.PREVIEW.RATE_WARNING',
          'Your rate is guaranteed for a limited amount of time. After that, a new quote will be required.'
        )}
      </div>
      <div>
        {tr('FRONTEND.WITHDRAW.BANK_TRANSFER.PREVIEW.RATE_TIME', 'Remaining time')}:{' '}
        <span className='rate-remaining-time'>{timeout.remainingTime}</span>
      </div>
    </div>
  )
}

export default FxRateTimerRow
